import { AnalyticsBrowser } from '@segment/analytics-next'

export const analytics = AnalyticsBrowser.load(
  {
    writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY!,
  },
  {
    integrations: {
      'Segment.io': {
        deliveryStrategy: {
          strategy: 'batching',
          config: {
            size: 10,
            timeout: 5000,
          },
        },
      },
    },
  }
)
